import { CloseIcon } from "@chakra-ui/icons";
import { Flex, Button } from "@chakra-ui/react";
import { FunnelComponentProps, FunnelContextArea } from "../../funnel/types";
import { Bundle } from "../../../types";

export interface PurchaseBundleModalHeaderProps extends FunnelComponentProps {
  bundle?: Bundle;
}

export function PurchaseBundleModalHeader({
  modalContext,
  onClose,
}: PurchaseBundleModalHeaderProps) {
  const isContextWithNoX = modalContext === FunnelContextArea.verticalReader;

  return (
    <Flex flexDirection="row" justifyContent="space-between" width="100%" padding="16px 24px">
      {isContextWithNoX ? null : (
        <Button
          alignSelf="center"
          variant="iconOnly"
          onClick={onClose}
          minWidth={0}
        >
          <CloseIcon alignSelf="center" color="dune.100" />
        </Button>
      )}
    </Flex>
  );
}